<div class="modal__wrapper">
  <div class="modal__title">
    {{
      ukrainianEvent
        ? ('PROJECT.direct_message_title' | translate)
        : ('HOMEPAGE.contact_form' | translate)
    }}
  </div>
  <div class="modal__description">
    {{
      ukrainianEvent
        ? ('PROJECT.direct_message_description' | translate)
        : ('HOMEPAGE.contact_form_desc' | translate)
    }}
  </div>
  <app-ph-input
    [placeholder]="'HOMEPAGE.contact_email' | translate"
    [validation]="'contactemail'"
    type="email"
    [showRequired]="true"
    name="email"
    [initValue]="storage.user ? storage.user.email : ''"
    [correctForm]="form"
  ></app-ph-input>
  <app-ph-input
    *ngIf="ukrainianEvent"
    [placeholder]="'HOMEPAGE.phone_number' | translate"
    [validation]="'phone_number'"
    type="text"
    [showRequired]="false"
    name="phoneNumber"
    [correctForm]="form"
  ></app-ph-input>
  <app-ph-input
    [placeholder]="'HOMEPAGE.contact_topic' | translate"
    [validation]="'contacttopic'"
    type="text"
    [showRequired]="true"
    name="title"
    [correctForm]="form"
  ></app-ph-input>
  <app-ph-input
    [placeholder]="'HOMEPAGE.ukrainian_contact_message' | translate"
    [validation]="'contactmessage'"
    type="textarea"
    [showRequired]="true"
    name="message"
    [correctForm]="form"
  ></app-ph-input>
  <app-ph-input
    *ngIf="ukrainianEvent"
    [validation]="'checkbox'"
    type="checkbox"
    name="contactConsent"
    [correctForm]="form"
  >
    {{ 'HOMEPAGE.i_agree' | translate }}</app-ph-input
  >
  <ngx-recaptcha2
    #captchaElem
    [siteKey]="recaptchaSiteKey"
    (success)="handleSuccessRecaptcha($event)"
    (error)="errorRecaptcha($event)"
  >
  </ngx-recaptcha2>
  <div class="modal__actions modal__actions--multiple">
    <button class="btn btn--outline btn--default btn--md mw-160" (click)="closeModal()">
      {{ 'HOMEPAGE.contact_close' | translate }}
    </button>
    <button
      class="btn btn--primary btn--md mw-160"
      [disabled]="form.invalid || loading || !captchaValid"
      (click)="submitContactForm(ukrainianEvent, project ? project.user.id : null)"
    >
      {{ 'HOMEPAGE.contact_send' | translate }}
    </button>
  </div>
</div>
